const initialState = {
    id : 0,
    id_fazenda: '',
    token: '',
    marca: '',
    modelo: '',
    data_ativacao: '',
    sistema: '',
    excluido: false,
    id_usuario: 0,
   };

export function usuarioDispositivo(state = initialState, action) {
    switch (action.type) {
        case 'FETECHED_ALL_USUARIODISPOSITIVO':
            return {
                ...state,
                usuarioDispositivo: action.usuarioDispositivo
            };
        case 'USUARIODISPOSITIVO_DETAIL':
            return {
                ...state,
                id: action.id,
                id_fazenda: action.id_fazenda,
                token: action.token,
                marca: action.marca,
                modelo: action.modelo,
                data_ativacao: action.data_ativacao,
                sistema: action.sistema,
                excluido: action.excluido,
                id_usuario: action.id_usuario,
               
            };
        case 'USUARIODISPOSITIVO_CLEAR':
            return {
                ...state,
                anchor: 'left',
                id: 0,
                id_fazenda: '',
                token: '',
                marca: '',
                modelo: '',
                data_ativacao: '',
                sistema: '',
                excluido: false,
                id_usuario: 0,
             
            };
        case "USUARIODISPOSITIVO_UPDATED":
            return state;
        case "HANDLE_ON_CHANGE":
            return {
                ...state,
                [action.props]: action.value
            };
        default:
            return state
    }
}
